import Perfil from "./Perfil";

export default class Usuario {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
    this.login = obj.login;
    this.email = obj.email;
    this.senha = obj.senha;
    this.idPerfil = obj.idPerfil;
    this.perfil = new Perfil(obj.perfil);
    this.idSetores = obj.idSetores;
    this.setores = obj.setores;
    this.dataInativacao = obj.dataInativacao;
    this.grupos = obj.grupos;
  }

  modeloValido() {
    return !!(this.nome && this.email && this.senha);
  }
}
